import styled from "styled-components"

const ContentMax = styled.div`
	max-width: ${props => props.theme.sizes.contentMax};
	margin: 0 auto;
`;

export default ContentMax